export default __webpack_public_path__ + "images/PO.4b9da91.png";